import http from "./http";

export function fetchBanners() {
  return http.get("/public/banners");
}

export function fetchCompanyInfo() {
  return http.get("/public/company-info");
}

export function fetchServices() {
  return http.get("/public/services");
}

export function fetchPosts(params) {
  return http.get("/public/posts", { params });
}

export function fetchPostBySlug(slug) {
  return http.get("/public/posts/" + slug);
}

export function submitContact(payload) {
  return http.post("/public/contact", payload);
}
